import script from "./SectionNewsCarousel.vue?vue&type=script&setup=true&lang=js"
export * from "./SectionNewsCarousel.vue?vue&type=script&setup=true&lang=js"

import "./SectionNewsCarousel.vue?vue&type=style&index=0&id=98b15f58&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-98b15f58"]])

export default __exports__